import React from 'react';
import {PcIllustratedThree} from './pc/PcIllustratedThree'; // 注意这里是默认导入
import {MobileIllustratedThree} from './mobile/MobileIllustratedThree'; // 注意这里是默认导入

function IllustratedThree({isMobile, clicked, clickNext, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileIllustratedThree {...commonProps} />;
    } else {
        return <PcIllustratedThree {...commonProps} />;
    }
}

export default IllustratedThree;